import { CircularProgress } from '@material-ui/core';
import { useAuth } from 'hooks/auth';
import { useNotification } from 'hooks/notification';
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { useModal } from '../../hooks/modal';
import './styles.css'


const customStyles = {
  content: {
    top: '50%',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(0, 0, 0, 0)',
    width: '100%',
    height: '100%',
  },
  overlay: {
    overflow: 'auto',
    transition: '(top 0.4s, opacity 0.4s)',
    zIndex: 100000,
    background: 'rgba(0, 0, 0, 0.4)',
  }
};

const LoadingModal = () => {
  const { loadingModal, setLoadingModal, status, setIgnoreQr, ignoreQr } = useModal();
  const { socket } = useAuth();
  const { selectedCompany } = useNotification();

  const [loading, setLoading] = useState(false);
  const [qrCode, setQrCode] = useState('');

  useEffect(() => {
    if (status && !ignoreQr) {
      setLoadingModal(true);
      if (status === "notLogged") {
        const getSockets = async () => {
          setLoading(true);
          await socket.emit('qrcode', {
            id: selectedCompany.id
          });

          await socket.on('qrcode', (data) => {
            setQrCode(data)
          });

          setTimeout(() => {
            setLoading(false);
          }, 6000)
        }
        getSockets();
      } else if(status === 'browserClose') {
        setLoadingModal(false);
      }

    } else {
      setLoadingModal(false);
    }
  }, [status]);

  const getInfo = (status) => {
    if (status !== 'notLogged' && status !== 'chatsAvailable' && status !== 'successChat') {
      return (
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div>Aguarde enquanto iniciamos a sessão
            status:{status}
          </div>
          <button style={{ marginTop: 20 }} onClick={() => { setLoadingModal(false); setIgnoreQr(true) }} className="loading-modal-return-button">Ignorar</button>
        </div>
      )
    } else if (status === 'notLogged') {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <div>Por favor, caso seja o proprietário, leia o QrCode, do contrário, contatar administração</div>
          {!loading ? (
            <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center' }}><img src={qrCode} alt="qrCode"></img>
              <button style={{ marginTop: 20 }} onClick={() => { setLoadingModal(false); setIgnoreQr(true) }} className="loading-modal-return-button">Ignorar</button>
            </div>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <div>Whatsapp conectado</div>
          <button onClick={() => setLoadingModal(false)} className="loading-modal-return-button">Ok !</button>
        </div>
      )
    }
  }


  return (
    <Modal
      isOpen={loadingModal}
      onRequestClose={() => setLoadingModal(false)}
      style={customStyles}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      <div className="loading-modal-container">
        <div className="loading-modal-center">
          {getInfo(status)}
        </div>
      </div>
    </Modal>
  )
}

export default LoadingModal;
